import PAGE_NAMES from '../data/constants';

const getUpsellPageName = ({ id }) => {
  if (id.includes('outline')) {
    return PAGE_NAMES.HOME;
  }

  if (id.includes('progress')) {
    return PAGE_NAMES.PROGRESS;
  }

  return PAGE_NAMES.IN_COURSE;
};

export default getUpsellPageName;
